import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { environment } from "../../config.env";
import { CurrentUserContext } from "../../App";
import TabView from "../material/tabView/tabView";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import * as medicalApi from "../../service/medicalApi";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";

const ENDPOINT_DOMAIN = environment.endpoint_domain || "";

const customStyles = {
  rows: {
    style: {
      // override the row height
      // '&:nth-child(even)': {
      //     background: '#effff4'
      // },
      // '&:not(:last-of-type)': {
      //     borderBottomWidth: 'none'
      // }
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      // background: '#B8DFC7',
      fontSize: 16,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      // display: 'flex',
      // justifyContent: 'center',
      borber: "1px solid #B8DFC7",
      width: "100%",
    },
  },
};

let day = new Date().toLocaleDateString("th-TH", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

function LaboratoryResult() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});

  const [credentialToken, setCredentialToken] = useState(null);

  const [LabList, setLabList] = useState([]);
  const [LabListfilter, setLabListFilter] = useState("");
  const [LabSelect, setLabSelect] = useState("");
  const [optionList, setOptionList] = useState([]);
  const [optionFilter, setoptionFilter] = useState("");
  
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.state?.["credential_token"] === undefined) {
      navigate("/dataAccessRights");
    } else {
      setCredentialToken(location.state?.["credential_token"]);
    }
  }, []);

  useEffect(() => {
    getLabInformation();
  }, [credentialToken]);

  useEffect(() => {
    //getLabInformation()
    setOptionList([
      { key: "", value: "ผลการตรวจทั้งหมด" },
      { key: "HLA-B*58:01", value: "HLA-B*58:01" },
      { key: "HLA-B*57:01", value: "HLA-B*57:01" },
      { key: "HLA-B*15:02", value: "HLA-B*15:02" },
      { key: "NAT2-diplotype", value: "NAT2-diplotype" },
      { key: "HLA-A*31:01", value: "HLA-A*31:01" },
      { key: "HLA-B*13:01", value: "HLA-B*13:01" },
    ]);
  }, []);

  useEffect(() => {
    setLabSelect("");
  }, [optionFilter]);

  const onChangeSelect = (e) => {
    setoptionFilter(e);
    const filtered = LabList.filter((item) => item.expr2.includes(e));
    setLabListFilter(filtered);
  };

  const getLabInformation = async () => {
    if (!credentialToken) {
      return;
    }
    setLoading(true);
    let res = await medicalApi.getLabInformation(credentialToken);
    setLoading(false);
    // console.log(res)
    if (res) {
      if (res["data"]["code"] === 200) {
        let labList = res["data"]["lab_list"];
        setLabList(labList);
        setLabListFilter(labList);
        setUser(res.data?.patient);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const urlify = (text) => {
    let urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function (url) {
      let hyperlink = url;
      if (!hyperlink.match("^https?:\/\/")) {
        hyperlink = "http://" + hyperlink;
      }
      return (
        '<a className="blue" href="' + url + '" target="_blank">' + url + "</a>"
      );
    });
  };

  const columnsListResult = [
    {
      name: "ลำดับ",
      selector: (item, index) => (
        // <div className="text-center w-[30px]">{index + 1}</div>
        <div className="text-center w-[30px]">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </div>
      ),
      wrap: true,
      width: "80px",
    },
    {
      name: "รายการ",
      selector: (item) => <div className="text-base">{item["expr2"]}</div>,
      wrap: true,
    },
    {
      name: "ผลการตรวจยีน",
      selector: (item) => (
        <div>
          {item["lab_classify"]["lab_result"]["result"]["result_name"].includes(
            "POSITIVE",
          ) ||
          item["lab_classify"]["lab_result"]["result"]["result_name"].includes(
            "SLOW",
          ) ||
          item["lab_classify"]["lab_result"]["result"]["result_name"].includes(
            "RAPID",
          ) ? (
            <div className="px-4 py-1 text-xs text-white bg-red-500 rounded-full">
              {item["lab_classify"]["lab_result"]["result"]["result_name"]}
            </div>
          ) : (
            <div className="px-4 py-1 text-xs text-white bg-green-900  rounded-full">
              {item["lab_classify"]["lab_result"]["result"]["result_name"]}
            </div>
          )}
          {/* {item["lab_classify"]["lab_result"]["result"]["result_name"] ==
                        "NEGATIVE" ? (
                        <div className="px-4 py-1 text-white bg-pink-500 rounded-full">
                            {item["lab_classify"]["lab_result"]["result"]["result_name"]}
                        </div>
                    ) : item["lab_classify"]["lab_result"]["result"]["result_name"] ==
                        "POSOTIVE" ? (
                        <div className="px-4 py-1 text-white bg-cyan-700 rounded-full">
                            {item["lab_classify"]["lab_result"]["result"]["result_name"]}
                        </div>
                    ) : (
                        <div className="px-4 py-1 text-white bg-amber-900  rounded-full">
                            {item["lab_classify"]["lab_result"]["result"]["result_name"]}
                        </div>
                    )} */}
        </div>
      ),
      wrap: true,
      width: "250px",
    },
    {
      name: "สรุปผลการตรวจเมื่อ",
      selector: (item) => (
        <div className="text-[#9e9e9e]">
          {moment(item["report_date"]).add(543, "years").format("DD MMMM YYYY")}
        </div>
      ),
      wrap: true,
      width: "220px",
    },
    {
      name: "",
      selector: (item) => (
        <div>
          <button
            className="w-20 p-[5px] text-[#42A1EF] text-center border border-[#42A1EF] rounded-md"
            onClick={() => setLabSelect(item["_id"])}
          >
            ดูผลแลป
          </button>
        </div>
      ),
      wrap: true,
      width: "120px",
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ค้นหาข้อมูลผู้ป่วย", url: "/search-for-patient-information" },
    { name: "ผลการตรวจทางเภสัชพันธุศาสตร์", url: "/permission-lab-patient" },
  ];

  return (
    <>
      <div className="global-page">
        {/* <HeadBar menu="labPatientResult" /> */}
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="ค้นหาข้อมูลผู้ป่วย" />
        {/* Patient Infomation */}
        <div className="lg:flex-col lg:items-center flex flex-row gap-5 w-full p-4 mb-4 bg-white rounded-md shadow-md">
          <div className="overflow-hidden aspect-square w-[15%]">
            <img
              className="h-full object-cover"
              src={`${user?.profile_image ? user?.profile_image : require("../../asset/icon/iconuser.svg")}`}
              alt="imguser"
            />
          </div>
          <div className="lg:items-center flex flex-col gap-5 justify-center w-full">
            <div className="lg:items-center flex flex-col gap-1">
              <p className="text-base text-[#4F9C9D]">ข้อมูลผลการตรวจยีน</p>
              <p className="text-lg font-bold text-[#4F9C9D]">
                {user?.pname} {user?.fname} {user?.lname}
              </p>
            </div>
            <div className="flex flex-row gap-8">
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-500">เลขบัตรประชาชน</p>
                <p className="text-lg font-bold">{user?.pid}</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-500">วันเกิด</p>
                <p className="text-lg font-bold">
                 {moment(user?.birthday, ["DD/MM/YYYY", "YYYY-MM-DD"])
                                .add(543, "years")
                                .format("DD MMMM YYYY")}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-500">อายุ</p>
                <p className="text-lg font-bold">
                  {moment(user?.birthday, ["DD/MM/YYYY", "YYYY-MM-DD"]).isValid()
                    ? moment().diff(moment(user?.birthday, ["DD/MM/YYYY", "YYYY-MM-DD"]), "years")
                    : "-"} ปี
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-500">เบอร์โทร</p>
                <p className="text-lg font-bold">{user?.phone_number}</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-base text-gray-500">อีเมล</p>
                <p className="text-lg font-bold">{user?.email}</p>
              </div>
            </div>
          </div>
        </div>
        <TabView
          value={optionFilter}
          list={optionList}
          select={onChangeSelect}
        />
        <div className="flex flex-col gap-1 p-2 w-full bg-white">
          <div className="text-xs text-gray-700">
            <FontAwesomeIcon icon={faClock} /> ข้อมูลประจำวันที่ {day}
          </div>
          {optionFilter == "" && <div>จำนวน {LabList.length} รายการ</div>}
        </div>
        <DataTable
          className="border-t-[2px] border-gray-200"
          keyField="_id"
          columns={columnsListResult}
          data={LabListfilter}
          customStyles={customStyles}
          pagination
          onChangePage={(page) => setCurrentPage(page)}
          onChangeRowsPerPage={(maxRows) => setRowsPerPage(maxRows)}
          noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
        />
        {LabSelect != "" && (
          <>
            {LabList.filter((item) => {
              return item["_id"]?.includes(LabSelect);
            }).map((item, idx) => {
              return (
                <>
                  <div className="overflow-hidden flex flex-col gap-[2px] w-full bg-gray-200 p-[2px] mt-10 rounded-md">
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ชื่อการตรวจ
                      </div>
                      <div className="w-full p-5 text-2xl font-bold">
                        {item["expr2"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ผลการตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {
                          item["lab_classify"]["lab_result"]["result"][
                            "result_name"
                          ]
                        }
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วัตถุประสงค์
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["lab_classify"]["lab_result"]["objective"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        หน่วยงานที่ส่งตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["customer_name"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วันที่เก็บตัวอย่าง
                      </div>
                      <div className="w-full p-5 text-base">
                        {moment(item["collect_date"])
                          .add(543, "years")
                          .format("DD MMMM YYYY")}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วันที่ตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {moment(item["report_date"])
                          .add(543, "years")
                          .format("DD MMMM YYYY")}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ผลการวิเคราะห์
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["testing_result"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        การแปลผล
                      </div>
                      <div className="w-full p-5 text-base">
                        {
                          item["lab_classify"]["lab_result"]["result"][
                            "interpretation"
                          ]
                        }
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ข้อมูลจากระบบ
                      </div>
                      <div className="w-full p-5 text-base">
                        ข้อมูลจากระบบ iLABplus หมายเลขตัวอย่าง{" "}
                        {item["testing_no"]} เลขที่รายงานผล{" "}
                        {item["report_no"] ? item["report_no"] : "-"}{" "}
                        วันที่ออกรายงานผล{" "}
                        {moment(item["report_date"])
                          .add(543, "years")
                          .format("D MMMM YYYY")}
                      </div>
                    </div>
                  </div>

                  {item["lab_classify"]["lab_result"]["result"][
                    "recommend_doctor"
                  ]?.length > 0 ? (
                    <>
                      <div className="w-full bg-[#93D3B1] rounded-md mt-5 p-5">
                        <div className="text-black font-bold">คำแนะนำ</div>
                        {item["lab_classify"]["lab_result"]["result"][
                          "recommend_doctor"
                        ].map((recommend, index) => {
                          return (
                            <>
                              <div className="flex justify-start gap-x-4">
                                <p className="mt-2">{index + 1}.</p>
                                <p
                                  className="mt-2"
                                  dangerouslySetInnerHTML={{
                                    __html: urlify(recommend),
                                  }}
                                />
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {item["note"] ? (
                    <>
                      <div className="w-full bg-[#FFEA9E] rounded-md mt-5 p-5">
                        {item["note"]}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
          </>
        )}
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default LaboratoryResult;
